import { createVueViewComponent } from "@/shared/utils/vue";



import { OperatorClient } from "@/operator/OperatorClient";



// import css
import "./../../assets/styles/scss/operator.scss";
import "./../../assets/styles/scss/primevue/themes/saga/saga-green/theme.scss";
// import components
import App from "./App.vue";


// todo: use in global scope
$(document).ready(function (e) {
    createVueViewComponent(App, {}, document.querySelector("#vue-app")!);

    const params = new URLSearchParams(window.location.search);
    const tableId = params.get("tableId");
    const billId = params.get("billId");
    const walleePostfinanceTransactionId = params.get("walleePostfinanceTransactionId");
    const externalPaymentId = params.get("externalPaymentId");

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const client = new OperatorClient($("#operatorapp"), {
        callbackParams:
            tableId != null
                ? {
                      tableId: tableId,
                      billId: billId == null ? undefined : billId,
                      externalPaymentId: externalPaymentId == null ? undefined : externalPaymentId,
                      walleePostfinanceTransactionId:
                          walleePostfinanceTransactionId == null ? undefined : walleePostfinanceTransactionId,
                  }
                : undefined,
    });
});
